import { BasicButton } from '../components/widgets/buttons';
import { DialogsRenderer } from '../components/widgets/dialog';
import { LeftSidebarLayout } from '../components/widgets/layouts';
import { NotificationToasterRenderer } from '../components/widgets/notificationToaster';
import React, { FC, FunctionComponent, Suspense } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { Main } from 'src/components/widgets/leftAppSidebar/leftAppSidebarStyles';
import { ItemMenu } from 'src/components/widgets/leftAppSidebar/Menu';
import { Logout } from 'src/components/widgets/toolbar/logout';
import { useRelayStore } from 'src/relay';
import { getPathName } from 'src/shared/helpers';
import styled, { ThemeProvider } from 'styled-components';
import ErrorPageBoundary from '../components/pages/_error';
import OverlayLoading from '../components/widgets/overlayLoading';
import { AppStateProvider } from '../shared/appState';
import { scrollbarsStyle } from '../shared/globals';
import theme from '../shared/theme';
import { administratorLayoutContainerQuery } from './__generated__/administratorLayoutContainerQuery.graphql';

const Container = styled.div`
    font-size: 14px;
    font-family: ${(props) => props.theme.app.font};
    color: ${(props) => props.theme.app.primary};
    min-height: 100%;
    padding: 0px;

    ${scrollbarsStyle}
`;

const ScrollTop: FC<{ children?: React.ReactNode }> = ({ children }) => {
    return <React.Fragment>{children}</React.Fragment>;
};

const ButtonsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
`;

const Sidebar = () => {
    const navigate = useNavigate();
    const query = useLazyLoadQuery<administratorLayoutContainerQuery>(
        graphql`
            query administratorLayoutContainerQuery {
                treeMenu
            }
        `,
        {}
    );

    const rootMenu = JSON.parse(query.treeMenu) as ItemMenu;
    const { invalidateRelayStore } = useRelayStore();

    return (
        <Main style={{ height: '100%', top: 0 }}>
            <ButtonsList>
                {rootMenu.menu.map((x) => {
                    return (
                        <BasicButton
                            key={x.urlPage}
                            onClick={() => {
                                navigate(getPathName(x.urlPage));
                            }}
                        >
                            {x.name}
                        </BasicButton>
                    );
                })}

                <BasicButton onClick={() => Logout({ invalidateRelayStore })}>Logout</BasicButton>
            </ButtonsList>
        </Main>
    );
};

export const AdmininistratorLayoutContainer: FunctionComponent<{ className?: string; children?: React.ReactNode }> = ({ className, children }) => {
    return (
        <AppStateProvider>
            <ThemeProvider theme={theme}>
                <NotificationToasterRenderer />
                <DialogsRenderer />
                <OverlayLoading />
                <ScrollTop>
                    <Router>
                        <Container className={className}>
                            <LeftSidebarLayout sidebar={<Sidebar />}>
                                <ErrorPageBoundary>
                                    <Suspense fallback={<OverlayLoading forceShow />}>{children}</Suspense>
                                </ErrorPageBoundary>
                            </LeftSidebarLayout>
                        </Container>
                    </Router>
                </ScrollTop>
            </ThemeProvider>
        </AppStateProvider>
    );
};
